import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconImages41: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconImages41"><Path d="M20.5 3.5H3.5V20.5H20.5V3.5Z" stroke="currentColor"/><Path d="M13 18.0001C15.2091 18.0001 17 16.2092 17 14.0001C14.5 13.5001 13.471 14.0287 12 15.4999C10.5 13.9999 9.5 13.5 7 13.9999C7 16.2091 8.79086 18.0001 11 18.0001H13Z" stroke="currentColor"/><Path d="M14.5 10V7L13.25 7.75L12 7L10.75 7.75L9.5 7V10C9.5 11.3807 10.6193 12.5 12 12.5C13.3807 12.5 14.5 11.3807 14.5 10Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconImages41;
